/**
 * room details controller
 */
angular.module('bookingApp')
    .controller('roomController',function($scope, sessionFactory, propertyFactory, appFactory, $filter, $routeParams, $http){
    $scope.session = sessionFactory;
    $scope.property = propertyFactory;
    $scope.baseApp = appFactory;

    sessionFactory.viewingRoom = $routeParams.id;
    sessionFactory.viewingPhoto = 0;
    sessionFactory.viewingRoomPrice = 0;
    // setup pax configuration settings
    $scope.viewedRoom = propertyFactory.rooms[sessionFactory.viewingRoom];
    // setup base and max pax
    sessionFactory.selectedRoom.basePax = $scope.viewedRoom && $scope.viewedRoom.rate ? $scope.viewedRoom.rate.basePax: 0;
    sessionFactory.selectedRoom.maxAdditonalPax = $scope.viewedRoom && $scope.viewedRoom.rate ? $scope.viewedRoom.rate.maxAdditionalPax: 0;
    sessionFactory.selectedRoom.maxPax = $scope.viewedRoom && $scope.viewedRoom.bookable ? $scope.viewedRoom.bookable.maxPax: 0; //(sessionFactory.selectedRoom.basePax + sessionFactory.selectedRoom.maxAdditonalPax);

    // update the sessionFactory.selectedRoom -> this needs to have the max pax reset based on the room availability * maxPax.
    if($scope.viewedRoom && $scope.viewedRoom.rate && $scope.viewedRoom.rate.isPaxRate) {
        sessionFactory.selectedRoom.maxPax = sessionFactory.selectedRoom.maxPax * propertyFactory.roomAvailabilities[$scope.viewedRoom.nonFilteredIndex].availableRooms;
    }

    // calculated remaining pax
    sessionFactory.selectedRoom.remainingPax.overall = sessionFactory.selectedRoom.maxPax - (sessionFactory.selectedRoom.selectedAdults + sessionFactory.selectedRoom.selectedChildren + sessionFactory.selectedRoom.selectedInfants);
    // setup the adult pax
    sessionFactory.selectedRoom.selectedAdults = sessionFactory.selectedRoom.basePax;
    sessionFactory.selectedRoom.selectedChildren = 0;
    sessionFactory.selectedRoom.selectedInfants = 0;

    // pre-populate with filter screen pax selector options
    if($scope.viewedRoom.rate.isPaxRate) {
        if (property.showGroupedPaxSelectors.adults) {
            var remainingPax = 0;
            if(sessionFactory.selectedFilters.groupFilters.adults > sessionFactory.selectedRoom.maxPax){
                sessionFactory.selectedRoom.selectedAdults = sessionFactory.selectedRoom.maxPax;
                remainingPax = session.selectedRoom.maxPax - sessionFactory.selectedRoom.selectedAdults;
            } else {
                sessionFactory.selectedRoom.selectedAdults = sessionFactory.selectedFilters.groupFilters.adults;
                remainingPax = session.selectedRoom.maxPax - sessionFactory.selectedRoom.selectedAdults;
            }
        }
        if (property.showGroupedPaxSelectors.children && $scope.viewedRoom.rate.isValidForChildren) {
            if(remainingPax > 0){
                if(sessionFactory.selectedFilters.groupFilters.children > remainingPax){
                    sessionFactory.selectedRoom.selectedChildren = remainingPax;
                    remainingPax = 0;
                } else {
                    sessionFactory.selectedRoom.selectedChildren = (sessionFactory.selectedFilters.groupFilters.children < remainingPax) ? session.selectedFilters.groupFilters.children : remainingPax;
                    remainingPax -= sessionFactory.selectedRoom.selectedChildren;
                }
            }
        }
        if (property.showGroupedPaxSelectors.infants && $scope.viewedRoom.rate.isValidForInfants) {
            if($scope.viewedRoom.bookable.infantsTakeAvail){
                if(remainingPax > 0){
                    if(sessionFactory.selectedFilters.groupFilters.infants > remainingPax){
                        sessionFactory.selectedRoom.selectedInfants = remainingPax;
                    } else {
                        sessionFactory.selectedRoom.selectedInfants = (sessionFactory.selectedFilters.groupFilters.infants < remainingPax) ? session.selectedFilters.groupFilters.infants : remainingPax;
                    }
                }
            } else { // if infants don't take availability then set as the pre filter selected value
                sessionFactory.selectedRoom.selectedInfants = session.selectedFilters.groupFilters.infants;
            }
        }
    }

    sessionFactory.selectedRoom.customValues = $scope.viewedRoom.customValues;

    $scope.paxError = false;
    // setup footer controls
    $scope.setupStandardCartFooter();
    $scope.footer.nextFunc = nextFooterFunc;
    $scope.getClass = getIconClass;


    // show price used for calculating hot deal
    $scope.getShowPrice = getShowPrice;
    $scope.calculatePricing = calculatePricing;
    $scope.getOptionArray = getOptionArray;
    $scope.addRoomToCart = addRoomToCart;
    $scope.hasFacilities = hasFacilities;
    $scope.validateRoomCustomFields = validateRoomCustomFields;

    // watcher for pax configuration
    $scope.$watch('session.selectedRoom', selectedRoomUpdated, true);

    function nextFooterFunc(){
        $scope.goToPage('cart');
    }

    function getIconClass(iconId){
        var iconClass = '';
        switch(iconId){
            case 0:
                iconClass = 'f-tv';
                break;
            case 1:
                iconClass = 'f-internet';
                break;
            case 2:
                iconClass = 'f-safe';
                break;
            case 3:
                iconClass = 'f-aircon';
                break;
            case 4:
                iconClass = 'f-phone';
                break;
            case 5:
                iconClass = 'f-disabled';
                break;
            case 6:
                iconClass = 'f-coffee';
                break;
            case 7:
                iconClass = 'f-spa';
                break;
        }
        return iconClass;
    }

    function validateRoomCustomFields(){
        var isValid = true,
            roomForm = $scope.roomForm;

        angular.forEach(sessionFactory.selectedRoom.customFields, function(customField){
            var customFieldSubForm = roomForm['customField' + customField.id],
                customFieldModel, value;
            if(typeof customFieldSubForm !== 'undefined') {
                customFieldModel = customFieldSubForm['customField' + customField.id];
                customFieldSubForm.$setDirty(true);
                if(typeof customFieldModel !== 'undefined'){
                    customFieldModel.$setDirty(true);
                    value = customFieldModel.$viewValue;
                    if(typeof value === 'undefined' || value === null) {
                        value = '';
                    }

                    angular.forEach(customFieldModel.$parsers, function(parsers){
                        parsers(value);
                    });

                    if(isValid){
                        isValid = (customFieldModel.$invalid !== true);
                    }
                    customFieldModel.$render();
                }
            }
        });

        return isValid;
    }

    function getShowPrice(room){
        var price = propertyFactory.prices[room];
        var totalPrice = $scope.getPricing(price,1,0,0);
        return totalPrice / sessionFactory.selectedFilters.nights;
    }

    // get the pricing
    function calculatePricing(){
        var prices = propertyFactory.prices[sessionFactory.viewingRoom];
        var adults = sessionFactory.selectedRoom.selectedAdults;
        var children = sessionFactory.selectedRoom.selectedChildren;
        var infants = sessionFactory.selectedRoom.selectedInfants;
        var paxConfig = RoomRatePricing.buildPaxConfiguration(adults, children, infants);
        var start = sessionFactory.selectedFilters.checkin;
        var end = sessionFactory.selectedFilters.checkout;
        var range = moment.range(start, end);
        var period = 'nights';
        if(propertyFactory.rooms[sessionFactory.viewingRoom].rate.isPaxRate){
            var paxConfig = paxConfigurationCalculator.buildPaxConfiguration(adults,children,infants);
            var maxPaxConfig = propertyFactory.rooms[sessionFactory.viewingRoom].maxPaxComponents;
            var infantsTakeAvailability = propertyFactory.rooms[sessionFactory.viewingRoom].bookable.infantsTakeAvail;
            var roomConfigs = paxConfigurationCalculator.getRoomConfiguration(paxConfig, maxPaxConfig, infantsTakeAvailability);
            // calculate the pricing based on the room configuration
            var total = 0;
            angular.forEach(roomConfigs, function(roomConfig){
                var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(prices, roomConfig, range, period);
                total += priceOb.total;
            });
            sessionFactory.viewingRoomPrice = total;
        } else {
            var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(prices, paxConfig, range, period);
            sessionFactory.viewingRoomPrice = priceOb.total;
        }
        // calculate the pricing based on the pax config
    }

    // pax option array creator
    function getOptionArray(type){
        var remainingPax = parseInt(sessionFactory.selectedRoom.remainingPax.overall);
        var selected = 0;
        switch(type){
            case "adults":
                selected = sessionFactory.selectedRoom.remainingPax.adults;
                break;
            case "children":
                selected = sessionFactory.selectedRoom.remainingPax.children;
                break;
            case "infants":
                selected = sessionFactory.selectedRoom.remainingPax.infants;
                break;
        }
        if (!Number.isInteger(selected)) {
            selected = 0;
        }
        var num = selected+1;
        var arrLength =  parseInt(num);
        if (!arrLength || arrLength < 1) {
            arrLength = 1;
        }
        return new Array(arrLength);
    }

    // add room to the cart
    function addRoomToCart(){

        var cartableRoomsPaxs = [];

        // room abilities
        if(propertyFactory.rooms[sessionFactory.viewingRoom].rate.isPaxRate){
            $scope.addPaxedRoomsToCart();
        } else {
            // check pax configurations has any pax added and validate any custom field
            if(!$scope.checkPax() || !$scope.validateRoomCustomFields()){
                return false;
            }
            var roomPaxConfig = {
                adults: sessionFactory.selectedRoom.selectedAdults,
                children: property.rooms[sessionFactory.viewingRoom].rate.isValidForChildren ? sessionFactory.selectedRoom.selectedChildren : 0,
                infants: property.rooms[sessionFactory.viewingRoom].rate.isValidForInfants ? sessionFactory.selectedRoom.selectedInfants : 0
            };
            $scope.pushPaxedRoomToCart(roomPaxConfig);
        }

        sessionFactory.roomGroupIndex++;

        // check if extras are part of the template
        if(propertyFactory.canSkipExtras) {
            $scope.goToPage('cart');
        } else {
            $scope.checkSelectedRoomsAreAvailable(function(){
                if($scope.property.isMultiProp){
                    $scope.session.isLoading = true;
                    $http.get('/front-booking/api-extras/',
                        {
                            params: {
                                bc: $scope.property.id,
                                sid: $scope.session.sid,
                                templateID: $scope.property.template.id,
                                dateIn: $filter('date')($scope.session.selectedFilters.checkin, 'yyyy-MM-dd'),
                                dateOut: $filter('date')($scope.session.selectedFilters.checkout, 'yyyy-MM-dd'),
                                format: 'json'
                            }
                        }
                    ).success(function (data, status, headers, config) {
                        var key, count = 0;
                        for(key in data.extras){
                            if(data.extras.hasOwnProperty(key)){
                                count++;
                            }
                        }
                        $scope.session.isLoading = false;
                        if(count > 0){
                            $scope.goToPage('extras');
                        } else {
                            $scope.goToPage('cart');
                        }
                    }).error(function(data, status, headers, config){
                        $scope.session.isLoading = true;
                        $scope.goToPage('extras');
                    });
                }else {
                    $scope.goToPage('extras');
                }
            });
            //$scope.goToPage('extras');
        }
        return true;
    }

    // check if a given room has any facilities
    function hasFacilities(room){
        var facilities = room.roomDetails.facilities;
        var hasFacilities = false;
        for(var facility in facilities){
            if(facilities.hasOwnProperty(facility)){
                if(facilities[facility]) {
                    hasFacilities = true;
                }
            }
        }
        return hasFacilities;
    }

    function selectedRoomUpdated(){
        sessionFactory.selectedRoom.selectedAdults = parseInt(sessionFactory.selectedRoom.selectedAdults);
        sessionFactory.selectedRoom.selectedChildren = parseInt(sessionFactory.selectedRoom.selectedChildren);
        sessionFactory.selectedRoom.selectedInfants = parseInt(sessionFactory.selectedRoom.selectedInfants);
        // use the configuration checker js object
        // get max values
        var maxAdults = $scope.viewedRoom.rate.basePax + $scope.viewedRoom.rate.maxAdditionalPax;
        var maxChildren = (typeof $scope.viewedRoom.rate.childRate !== 'undefined') ? ($scope.viewedRoom.rate.childRate.basePax + $scope.viewedRoom.rate.childRate.maxAdditionalPax) : sessionFactory.selectedRoom.maxPax;
        var maxInfants = (typeof $scope.viewedRoom.rate.infantRate !== 'undefined') ? ($scope.viewedRoom.rate.infantRate.basePax + $scope.viewedRoom.rate.infantRate.maxAdditionalPax) : sessionFactory.selectedRoom.maxPax;
        var infantTakesAvailability = $scope.viewedRoom.bookable.infantsTakeAvail;
        if($scope.viewedRoom.rate.isPaxRate) {
            maxAdults = sessionFactory.selectedRoom.maxPax * propertyFactory.roomAvailabilities[$scope.viewedRoom.nonFilteredIndex].availableRooms;
            maxChildren = maxAdults;
            maxInfants = infantTakesAvailability ? maxAdults : 15;
        }
        var maxPaxConfigOb = configurationChecker.generateMaxPaxConfigObject(sessionFactory.selectedRoom.maxPax, maxAdults, maxChildren, maxInfants, true, true, infantTakesAvailability);

        var incrementConfigOb = configurationChecker.generateIncrementPaxObject(sessionFactory.selectedRoom.selectedAdults, sessionFactory.selectedRoom.selectedChildren, sessionFactory.selectedRoom.selectedInfants);
        var configOutput = configurationChecker.updateMaxPax(maxPaxConfigOb, incrementConfigOb);
        // setup the remaining pax values
        sessionFactory.selectedRoom.remainingPax = {};
        sessionFactory.selectedRoom.remainingPax.adults = configOutput.available.adults;
        sessionFactory.selectedRoom.remainingPax.children = configOutput.available.children;
        sessionFactory.selectedRoom.remainingPax.infants = configOutput.available.infants;
        // update the pax remaining
        sessionFactory.selectedRoom.remainingPax.overall = sessionFactory.selectedRoom.maxPax - (sessionFactory.selectedRoom.selectedAdults + sessionFactory.selectedRoom.selectedChildren + ($scope.viewedRoom.bookable.infantsTakeAvail ? sessionFactory.selectedRoom.selectedInfants : 0));
        // re-calculate the pricing
        $scope.calculatePricing();
    }

});

var configurationChecker = {
    updateMaxPax: function(maxPaxConfigOb, incrementOb){
        var paxLeft = maxPaxConfigOb.maxPax - this.totalPaxTaken(maxPaxConfigOb, incrementOb); // 4 - 2 = 2
        var adultsLeft = maxPaxConfigOb.maxPaxAdults - incrementOb.adults;
        var childrenLeft = maxPaxConfigOb.maxPaxChildren - incrementOb.children;
        var infantsLeft = maxPaxConfigOb.maxPaxInfants - incrementOb.infants;

        var maxPaxCalc = {};
        // calculate what has been used
        maxPaxCalc.used = {};
        maxPaxCalc.used.adults = incrementOb.adults;
        maxPaxCalc.used.children = incrementOb.children;
        maxPaxCalc.used.infants = incrementOb.infants;
        // calculate what is left
        maxPaxCalc.left = {};
        maxPaxCalc.left.adults = maxPaxConfigOb.maxPaxAdults - incrementOb.adults;
        maxPaxCalc.left.children = maxPaxConfigOb.maxPaxChildren - incrementOb.children;
        maxPaxCalc.left.infants = maxPaxConfigOb.maxPaxInfants - incrementOb.infants;
        // calculate what is available
        maxPaxCalc.available = {};
        if(maxPaxConfigOb.takesPaxAdult) {
            maxPaxCalc.available.adults = (adultsLeft <= paxLeft) ? adultsLeft + maxPaxCalc.used.adults : paxLeft + maxPaxCalc.used.adults;
        } else {
            maxPaxCalc.available.adults = maxPaxConfigOb.maxPaxAdults;
        }
        if(maxPaxConfigOb.takesPaxChildren) {
            maxPaxCalc.available.children = (childrenLeft <= paxLeft) ? childrenLeft + maxPaxCalc.used.children : paxLeft + maxPaxCalc.used.children;
        } else {
            maxPaxCalc.available.children = maxPaxConfigOb.maxPaxChildren;
        }
        if(maxPaxConfigOb.takesPaxInfants) {
            maxPaxCalc.available.infants = (infantsLeft <= paxLeft) ? infantsLeft + maxPaxCalc.used.infants : paxLeft + maxPaxCalc.used.infants;
        } else {
            maxPaxCalc.available.infants = maxPaxConfigOb.maxPaxInfants;
        }

        return maxPaxCalc;
    },
    totalPaxTaken: function(maxPaxConfigOb, incrementOb){
        var total = 0;
        if(maxPaxConfigOb.takesPaxAdult){
            total += incrementOb.adults;
        }
        if(maxPaxConfigOb.takesPaxChildren){
            total += incrementOb.children;
        }
        if(maxPaxConfigOb.takesPaxInfants){
            total += incrementOb.infants;
        }
        return total;
    },
    generateIncrementPaxObject : function(adults, children, infants){
        var paxIncrementConfig = {};
        paxIncrementConfig.adults = adults;
        paxIncrementConfig.children = children;
        paxIncrementConfig.infants = infants;
        return paxIncrementConfig;
    },
    generateMaxPaxConfigObject : function(maxPax, maxAdults, maxChildren, maxInfants, adultsTakesPax, childrenTakesPax, infantsTakesPax){
        var maxPaxConfig = {};
        maxPaxConfig.maxPax = maxPax;
        maxPaxConfig.maxPaxAdults = maxAdults;
        maxPaxConfig.maxPaxChildren = maxChildren;
        maxPaxConfig.maxPaxInfants = maxInfants;
        maxPaxConfig.takesPaxAdult = typeof adultsTakesPax !== 'undefined' ? adultsTakesPax : true;
        maxPaxConfig.takesPaxChildren = typeof childrenTakesPax !== 'undefined' ? childrenTakesPax : true;
        maxPaxConfig.takesPaxInfants = typeof infantsTakesPax !== 'undefined' ? infantsTakesPax : false;
        return maxPaxConfig;
    },
    testFunctionality : function(){
        var maxPaxConfig = this.generateMaxPaxConfigObject(4,3,3,3,true,true,false);
        var incrementPaxOb = this.generateIncrementPaxObject(2,1,0);
        console.log(this.updateMaxPax(maxPaxConfig, incrementPaxOb));
    }
};
